import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=12484b4f&"
import script from "./UserRow.vue?vue&type=script&lang=js&"
export * from "./UserRow.vue?vue&type=script&lang=js&"
import style0 from "./UserRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports